export default "__VITE_ASSET__0wsrZDZB__"